import { initSentry } from './sentry'

initSentry()
